import { useMemo } from 'react'
import useSWR from 'swr'

export const useCurrentGroup = (): [string | undefined, { isLoading: boolean; error?: any }] => {
  const { data: infoRes, error } = useSWR<{ data: { group: string } }>('/info')
  return useMemo(() => [infoRes?.data?.group, { error, isLoading: !infoRes && !error }], [infoRes, error])
}
